import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import {
  AccredibleListComponentModule,
  AccredibleListItemComponentModule,
} from '@accredible-frontend-v2/new-components/list';
import { AccredibleTooltipModule } from '@accredible-frontend-v2/new-components/tooltip';
import { AccredibleSyncOrAsyncPipeModule } from '@accredible-frontend-v2/pipes/sync-or-async';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SelectInputComponent } from './select-input.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    AccredibleIconComponentModule,
    AccredibleListComponentModule,
    AccredibleListItemComponentModule,
    AccredibleSyncOrAsyncPipeModule,
    A11yModule,
    AccredibleTooltipModule,
    TranslocoModule,
  ],
  declarations: [SelectInputComponent],
  exports: [SelectInputComponent],
})
export class AccredibleSelectInputComponentModule {}
